module.exports = __webpack_public_path__ + "bodum.svg?9a526f2abb933a4feda55812cce238f0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bodum.svg
// module id = 174
// module chunks = 0